// @flow
import * as React from 'react';
import prop from 'ramda/es/prop';
import last from 'ramda/es/last';

import ParamsContext from './ParamsContext';


/**
 * Контекст для параметров роутера
 */

type Props = {
  children: any,
  params: Object,
  route?: { path: string },
  routes?: Array<Object>,
  location: {
    pathname: string,
  },
  router: {
    push: Function,
    replace: Function,
  },
}

const WithRouterParamsProviderV3 = ({
  children,
  params,
  route,
  routes,
  location: { pathname },
  router: { push, replace },
}: Props) => {
  const pathMask = prop('path', route) || prop('path', last(routes)) || '';

  return (
    <ParamsContext.Provider
      value={{
        params,
        pathname,
        push,
        replace,
        pathMask,
      }}
    >
      {children}
    </ParamsContext.Provider>
  );
};

export default WithRouterParamsProviderV3;
